const getUrl = ({ authUrl, path }: { authUrl: string; path: string }) => {
  return `${authUrl}${path}`
}

export const getAuthAppUrls = (authUrl: string) => ({
  get signIn() {
    return getUrl({ authUrl, path: '/sign-in' })
  },
  get signUp() {
    return getUrl({ authUrl, path: '/sign-up' })
  },
})
